export default "__VITE_ASSET__Bv309wuU__"